var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-item"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_c('span',{directives:[{name:"empty",rawName:"v-empty"}],staticClass:"value"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }